var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container form-container" }, [
      _c("div", { staticClass: "row pb-3" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("div", { staticClass: "clinical-trials-content" }, [
            _c("h2", { class: _vm.post_title_h_style }, [
              _vm._v(_vm._s(_vm.post_title)),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.post_description))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "form",
            { staticClass: "vue-app", attrs: { id: "event-search-form" } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12 col-md-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.blog,
                            expression: "form.blog",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "blogCheckbox",
                          value: "Blogs",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.blog)
                            ? _vm._i(_vm.form.blog, "Blogs") > -1
                            : _vm.form.blog,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.blog,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Blogs",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(_vm.form, "blog", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "blog",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "blog", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "blogCheckbox" },
                        },
                        [_vm._v("Blogs")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.news,
                            expression: "form.news",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "newsCheckbox",
                          value: "News",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.news)
                            ? _vm._i(_vm.form.news, "News") > -1
                            : _vm.form.news,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.news,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "News",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(_vm.form, "news", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "news",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "news", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "newsCheckbox" },
                        },
                        [_vm._v("News")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("startdate", {
                        attrs: {
                          placeholder: "Start Date",
                          name: "post_date",
                          "clear-button": true,
                          typeable: true,
                        },
                        model: {
                          value: _vm.form.start_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "start_date", $$v)
                          },
                          expression: "form.start_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("enddate", {
                        attrs: {
                          placeholder: "End Date",
                          name: "end_date",
                          "clear-button": true,
                          typeable: true,
                        },
                        model: {
                          value: _vm.form.end_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end_date", $$v)
                          },
                          expression: "form.end_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row mb-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("multiselect", {
                        ref: "search_physician",
                        attrs: {
                          id: "search-physician",
                          options: _vm.physicians,
                          multiple: true,
                          placeholder: "Physicians",
                          "close-on-select": false,
                          "clear-on-select": true,
                          selectLabel: "Press enter or click to select",
                          deselectLabel: "Press enter or click to remove",
                          label: "text",
                          "track-by": "id",
                          maxHeight: _vm.dropdownHeight,
                        },
                        on: {
                          open: _vm.onMultiselectOpen,
                          close: _vm.onMultiselectClose,
                        },
                        model: {
                          value: _vm.form.physician,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "physician", $$v)
                          },
                          expression: "form.physician",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("multiselect", {
                        ref: "search_location",
                        attrs: {
                          id: "search-location",
                          options: _vm.locations,
                          multiple: true,
                          placeholder: "Locations",
                          "close-on-select": false,
                          "clear-on-select": true,
                          selectLabel: "Press enter or click to select",
                          deselectLabel: "Press enter or click to remove",
                          label: "text",
                          "track-by": "id",
                          maxHeight: _vm.dropdownHeight,
                        },
                        on: {
                          open: _vm.onMultiselectOpen,
                          close: _vm.onMultiselectClose,
                        },
                        model: {
                          value: _vm.form.location_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "location_id", $$v)
                          },
                          expression: "form.location_id",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row pt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary mx-1",
                    attrs: { type: "submit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.searchNews(true)
                      },
                    },
                  },
                  [_vm._v("Search")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark",
                    attrs: { type: "submit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.resetForm()
                      },
                    },
                  },
                  [_vm._v("Reset Form")]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid clip-path-ellipse-concave-concave",
        attrs: { id: "news-featured-post" },
      },
      [
        _c("div", { staticClass: "container py-3" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("news-featured", {
                attrs: { featured_post: _vm.featured_post },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid", attrs: { id: "news-results-wrap" } },
      [
        _c("div", { staticClass: "container py-3" }, [
          _c(
            "div",
            {
              staticClass: "row vue-search-results",
              attrs: { id: "news-results" },
            },
            [
              _c("div", { staticClass: "col-12 pb-3" }, [
                _vm._v(
                  "\n            Showing " +
                    _vm._s(_vm.min_count) +
                    " - " +
                    _vm._s(_vm.count) +
                    " of " +
                    _vm._s(_vm.total_count) +
                    " results\n        "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.news, function (post) {
                return _c("news-results", {
                  key: post["title"],
                  attrs: { news: post },
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  class: { "d-none": _vm.total_count || !_vm.initialized },
                },
                [_vm._v(_vm._s(_vm.no_results_message))]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container py-2", class: { "d-none": _vm.has_more } },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showMoreCards()
                    },
                  },
                },
                [_vm._v("Load More Results")]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("strong", { staticClass: "h5" }, [_vm._v("Filter Articles By:")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }